export default "__VITE_ASSET__5vjcmdNq__"